import $ from 'jquery';
import '../libs/bililiteRange.js';

if (typeof window !== 'undefined') {
  window.$ = window.$ || $;
  window.jQuery = window.jQuery || $;
}
